import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

function SoldPlotsDetails() {
  const [soldPlots, setSoldPlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [projectName, setProjectName] = useState("");
  const [error, setError] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const projectId = queryParams.get("project_id");
  const navigate = useNavigate();

  const getAuthToken = () => localStorage.getItem("token");

  const fetchSoldPlots = async () => {
    if (!projectId) {
      setError("Project ID not found in URL");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const token = getAuthToken();

      if (!token) {
        setError("Authentication required. Please login again.");
        setLoading(false);
        return;
      }

      console.log("Fetching sold plots for project:", projectId);

      const response = await fetch(
        `${API_URL}/plot-list-base-project?project_id=${projectId}&page=1&limit=1000`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("Response status:", response.status);

      if (response.status === 401) {
        setError("Session expired. Please login again.");
        localStorage.removeItem("token");
        localStorage.removeItem("isLoggedIn");
        setLoading(false);
        return;
      }

      if (!response.ok) {
        throw new Error(`Failed to fetch: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response:", data);

      // Filter only sold plots
      if (data.status === "1" && data.data && data.data.length > 0) {
        const sold = data.data.filter(
          (plot) => plot.status && plot.status.toLowerCase() === "sold",
        );
        console.log("Sold plots found:", sold.length);
        setSoldPlots(sold);

        // Get project name
        if (sold.length > 0 && sold[0]?.project_name) {
          setProjectName(sold[0].project_name);
        }
      } else {
        setSoldPlots([]);
        if (data.message) {
          setError(data.message);
        }
      }
    } catch (err) {
      console.error("Sold plots fetch error:", err);
      setError(err.message || "Failed to load sold plots");
      setSoldPlots([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSoldPlots();
  }, [projectId]);

  // Format currency
  const formatCurrency = (value) => {
    if (!value) return null;
    const num = Number(value);
    if (isNaN(num)) return null;
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 0,
    }).format(num);
  };

  // Error State
  if (error) {
    return (
      <div className="padding_15 px-0">
        <div className="card">
          <div className="card-header">
            <div className="d-flex align-items-center justify-content-between">
              <div className="titlepage">
                <h3>Sold Plots History</h3>
              </div>
              <div className="backbutton">
                <Link to={`/blocklists?project_id=${projectId}`}>Back</Link>
              </div>
            </div>
          </div>
          <div className="card-body text-center py-5">
            <div style={{ fontSize: "60px", marginBottom: "20px" }}>⚠️</div>
            <h4 className="text-danger">Error Loading Data</h4>
            <p className="text-muted">{error}</p>
            <div className="mt-3">
              <button
                className="btn btn-primary me-2"
                onClick={() => fetchSoldPlots()}
              >
                Retry
              </button>
              <Link
                to={`/blocklists?project_id=${projectId}`}
                className="btn btn-secondary"
              >
                Go Back
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Loading State
  if (loading) {
    return (
      <div className="padding_15 px-0">
        <div className="card">
          <div className="card-header">
            <div className="d-flex align-items-center justify-content-between">
              <div className="titlepage">
                <h3>Sold Plots History</h3>
              </div>
              <div className="backbutton">
                <Link to={`/blocklists?project_id=${projectId}`}>Back</Link>
              </div>
            </div>
          </div>
          <div className="card-body text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading sold plots...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="padding_15 px-0">
      <div className="card">
        <div className="card-header">
          <div className="d-flex align-items-center justify-content-between">
            <div className="titlepage">
              <h3>
                Sold Plots Details
                {/* {projectName && (
                  <small
                    className="text-muted ms-2"
                    style={{ fontSize: "14px" }}
                  >
                    - {projectName}
                  </small>
                )} */}
              </h3>
              {/* <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                Project ID: #{projectId} | Total Sold: {soldPlots.length}
              </p> */}
            </div>
            <div className="d-flex gap-2">
              <Link
                to={`/blocklists?project_id=${projectId}`}
                className="btn btn-success fw-bold"
              >
                Back
              </Link>
            </div>
          </div>
        </div>

        <div className="card-body">
          {soldPlots.length > 0 ? (
            <>
              {/* Summary Stats */}
              <div className="row mb-4">
                <div className="col-md-4 col-6">
                  <div className="bg_card_design border rounded p-3 h-100">
                    <h6 className="text-muted mb-1">Total Sold</h6>
                    <h3 className="mb-0 text-success">{soldPlots.length}</h3>
                  </div>
                </div>
                {/* <div className="col-md-4 col-6">
                  <div className="bg_card_design border rounded p-3 h-100">
                    <h6 className="text-muted mb-1">Project ID</h6>
                    <h3 className="mb-0 text-primary">#{projectId}</h3>
                  </div>
                </div> */}
                <div className="col-md-4 col-6 mt-2 mt-md-0">
                  <div className="bg_card_design border rounded p-3 h-100">
                    <h6 className="text-muted mb-1">Project Name</h6>
                    <h5 className="mb-0 text-dark">{projectName || "N/A"}</h5>
                  </div>
                </div>
              </div>

              {/* Sold Plots Grid */}
              <div className="plot-chessboard">
                <div className="chessboard-grid">
                  {soldPlots.map((plot) => (
                    <div key={plot.id} className="chess-cell cell-sold">
                      {/* Plot Number */}
                      <div className="plot-number">
                        {String(plot.plot_shop_villa_no || "-").toUpperCase()}
                      </div>

                      {/* Status */}
                      <div className="plot-status sold-status">
                        {plot.status || "sold"}
                      </div>

                      {/* Area */}
                      {plot.area_sqyd && (
                        <div className="plot-area">{plot.area_sqyd} sqyd</div>
                      )}

                      {/* Price */}
                      {plot.rate && (
                        <div className="plot-rate sold-rate">
                          ₹{formatCurrency(plot.rate)}/sqyd
                        </div>
                      )}

                      {/* Customer */}
                      {plot.customer_name && (
                        <div
                          className="plot-customer"
                          title={plot.customer_name}
                        >
                          👤 {plot.customer_name}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div className="text-center py-5">
              <div style={{ fontSize: "48px", marginBottom: "20px" }}>📊</div>
              <h4>No Sold Plots Found</h4>
              <p className="text-muted">
                No sold plots available for this project.
              </p>
              <Link
                to={`/blocklists?project_id=${projectId}`}
                className="btn btn-primary mt-3"
              >
                Go Back
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SoldPlotsDetails;
